import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Link from '../../utils/link';

import Typography from '../../atoms/typography';

const BreadCrumbList = styled.ol`
  display: flex;
  flex-direction: row;
  grid-area: breadcrumbs;
  margin: 0 -1rem 3rem 0;
`;

const BreadCrumbAnchor = styled.a`
  color: ${(props) => props.theme.color.brandLight};
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  letter-spacing: 0.2em;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
`;

const BreadCrumbItem = styled(Typography)`
  padding: 0 1rem;
  position: relative;
  line-height: 1.5rem;
  white-space: nowrap;

  & + & {
    &:before {
      color: ${(props) => props.theme.color.brandLight};
      content: '\u007C';
      position: absolute;
      left: -1px;
    }
  }

  &:last-of-type {
    ${BreadCrumbAnchor} {
      color: ${(props) => props.theme.color.brand};
      white-space: normal;
    }
    padding-right: 0;
  }

  &:first-of-type {
    padding-left: 0;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    &:first-of-type {
      padding-left: 1rem;
    }
  }
`;

const BreadCrumbs = (props) => {
  const getBreadcrumbs = () => props.breadcrumbs.reduce((acc, crumb) => {
    const cats = crumb.url.split('/category/')[1];

    const breadcrumb = {
      name: crumb.name,
      href: `/shop/${cats}`
    };

    return [...acc, breadcrumb];
  }, []);

  const [breadcrumbs] = useState(getBreadcrumbs());

  return (
    breadcrumbs && (
      <BreadCrumbList>
        {
          getBreadcrumbs().map((crumb) => (
            <BreadCrumbItem key={crumb.name} element="li" like="label-1">
              <Link passHref href={crumb.href}>
                <BreadCrumbAnchor>{crumb.name}</BreadCrumbAnchor>
              </Link>
            </BreadCrumbItem>
          ))
        }
      </BreadCrumbList>
    )
  );
};

BreadCrumbs.propTypes = {
  breadcrumbs: PropTypes.array.isRequired
};

export default BreadCrumbs;
